<template>
  <th>
    <div class="flex items-center relative">
      <span>{{ label }}</span>
      <template v-if="hasSort">
        <svg v-if="sort === 'none'" v-on:click="cycleSort('none')" class="cursor-pointer ml-auto h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
          <path fill-rule="evenodd" d="M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clip-rule="evenodd" />
        </svg>
        <svg v-if="sort === 'asc'" v-on:click="cycleSort('asc')" class="cursor-pointer ml-auto h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd" d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z" clip-rule="evenodd" />
        </svg>
        <svg v-if="sort === 'desc'" v-on:click="cycleSort('desc')" class="cursor-pointer ml-auto h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
          <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
        </svg>
      </template>
    </div>
  </th>
</template>

<script>
export default {
  name: "TableHeading",
  props: {
    label: {
      type: String,
    },
    innerClass: {
      type: String,
    },
    hasFilter: {
      type: Boolean,
      default: false,
    },
    hasSort: {
      type: Boolean,
      default: false,
    },
    defaultSort: {
      type: String,
    },
    onlySort: {
      type: Array
    }
  },
  data () {
    return {
      sorts: [
        'none',
        'asc',
        'desc',
      ],
      sort: 'none',
      filter: null,
      filterApplied: false,
      showFilter: false
    }
  },
  mounted () {
    if (this.defaultSort) {
      this.sort = this.defaultSort;
    }

    if (this.onlySort) {
      this.sorts = this.onlySort;
    }
  },
  methods: {
    cycleSort (direction) {
      let currentSort = this.sorts.indexOf(direction);
      const nextSort = (currentSort + 1) % (this.sorts.length);

      this.sort = this.sorts[nextSort];
      this.$emit('sort', this.sort);
    },
    toggleFilter () {
      this.showFilter = !this.showFilter;
    },
    applyFilter () {
      this.$emit('filter', this.filter);
      this.filterApplied = true;
      this.closeFilter();
    },
    closeFilter () {
      this.showFilter = false;
    },
    clearFilter () {
      this.$emit('clear-filter');
      this.filter = null;
      this.filterApplied = false;
    }
  }
}
</script>
